<script setup lang="ts">
import { onMounted } from 'vue';
import { getGoogleDriveUrl } from '~/utils';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-alert
    type="success"
    message="As custas foram enviadas para pagamento"
    show-icon
  />

  <a-descriptions
    :column="3"
    :label-style="{ width: '15%' }"
    style="margin-top: 24px"
    bordered
  >
    <a-descriptions-item label="Arquivos" :span="3">
      <span v-if="props.compromisso.arquivos.length === 0"
        >Nenhum arquivo enviado</span
      >
      <ul v-else>
        <li
          v-for="arquivo in props.compromisso.arquivos"
          :key="arquivo.fileServiceId"
        >
          <a target="_blank" :href="getGoogleDriveUrl(arquivo.fileServiceId)">{{
            arquivo.nome
          }}</a>
        </li>
      </ul>
    </a-descriptions-item>
  </a-descriptions>
</template>
